<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Jose Martin de la Cruz Vicencio
    Author URL: http://martinvicencio.com
========================================================================================== -->

<template>
  <vx-card title="Alumnos Re-Inscritos (Con pago)" code-toggler>
        <div class="row">
         <div class="col-1">
                Año
                <div>
                  <v-select label="anio" v-model="anioList" :options="anios">
                    </v-select>
                </div>
            </div>
            <div class="col-2">
                Periodo
                <div>
                    <v-select label="nombre" @change="onChangePeriodoList($event)" v-model="periodoList" :options="periodosList"></v-select>
                </div>
            </div>

          <!-- <div class="col-2">
                Carrera
                <div>
                    <v-select class="float-left" @change="onChangeCarreraList($event)" style="width: 100%;" label="nombre" v-model="carreraListSelected" :options="carreras">
                    </v-select>
                </div>
            </div> -->


        <div class="col-4">        
             <!-- continuara la version en excel de Alumnos activos -->
            <vue-excel-xlsx class="vs-component vs-button vs-button-primary vs-button-filled float-right"
                    :data="alumnos"
                    :columns="columns"
                     style="margin: 10px;"
                    :filename="'ResultadosMatriculaConPagoReInscripcion'"
                    :sheetname="'Resultado'">
                    <!-- :sheetname="'Kardex'"> -->
                Descargar Archivo en Excel (XLS)
            </vue-excel-xlsx>

          </div>

</div>
<br>

 <div class="col-4">
             <!-- <h3>Total de Alumnos Re-inscritos: {{total}}</h3>   -->
              <div v-show="total>1" class="alert alert-info" role="alert"> Total de Alumnos Re-inscritos:<b>{{total}}  </b> </div>
            </div>
                                                 
    <vs-table search pagination :maxItems="1600" stripe :data="alumnos">

      <template slot="thead">
        <vs-th>No.</vs-th>
        <vs-th>Id</vs-th>
        <vs-th sort-key="matricula">Matricula</vs-th>
        <vs-th>Nombre</vs-th>
        <vs-th sort-key="curp">Curp</vs-th>
        <vs-th sort-key="carrera">Carrera</vs-th>
         <vs-th sort-key="activo">Activo</vs-th>
        <vs-th>Referencia</vs-th>
        <vs-th>Cantidad Pago</vs-th>
        <!-- <vs-th  colspan="2" style="text-align: center;"> Acciones</vs-th> -->
        

        <!-- <vs-th>Cambio de carrera</vs-th> -->
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
         
          <vs-td :data="data[indextr].idAlumno">
            <!-- {{indextr+1}} -->
              {{ indextr + 1 }}
          </vs-td>

           <vs-td :data="data[indextr].idAlumno">
            {{data[indextr].idAlumno}}
          </vs-td>

          <vs-td :data="data[indextr].matricula">
            {{data[indextr].matricula}}
          </vs-td>
          <vs-td :data="data[indextr].nombreAlumno">
            {{data[indextr].nombreAlumno}}
          </vs-td>
          <vs-td :data="data[indextr].curp">
        {{data[indextr].curp}}
          </vs-td>
          <vs-td :data="data[indextr].carrera">
            {{data[indextr].carrera}}
          </vs-td>

          <!-- <vs-td :data="data[indextr].cuatrimestre">
            {{data[indextr].cuatrimestre}}
          </vs-td> -->

          <vs-td :data="data[indextr].activo">
            <div v-if="data[indextr].activo=='SI'">
                    <span class="alert alert-success" role="alert"> SI  </span>
             </div> 
                  <div v-else >
                        <span class="alert alert-danger" role="alert">NO  </span>
                              </div> 
           </vs-td> 

         
          <vs-td  :data="data[indextr].referencia">
              {{data[indextr].referencia}}
            </vs-td>
            
               <vs-td  :data="data[indextr].cantidadPago">
              {{data[indextr].cantidadPago}}
            </vs-td>
 
        </vs-tr>
      </template>

      

    </vs-table>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select'
    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'
    import Table from "../ui-elements/table/Table";
    import Button from "../components/vuesax/button/Button";

export default {
  data() {
    return {

      id_rol: this.getKey('id_rol'), 
      total:'',
      // carrera: localStorage.getItem('id_carrera'),
      // cuatrimestre_actual: [{ nombre: "", idAgno: "" }],
      // alumno_detalle: [],
      alumnos: [],
     anios:[],
     anioList:{},
      periodosList:[],
      periodoList:{},
      estados:[],
       municipios:[],
      columns : [
                    // {
                    //     label: "Número",
                    //     field: "numero",
                    // },
                    {
                        label: "Id",
                        field: "idAlumno",
                        dataFormat: this.priceFormat
                    },
                    {
                        label: "Matricula",
                        field: "matricula",
                    },
                    {
                      label: "Nombre",
                        field: "nombreAlumno",
                       
                    },
                    {
                      label: "Curp",
                        field: "curp",   
                    },

                    {
                        label: "Carrera",
                        field: "carrera",
                    },

                    {
                        label: "Activo",
                        field: "activo",
                    },
{
                        label: "Referencia",
                        field: "referencia",
                    },
                    {
                         label: "Cantidad Pago",
                        field: "cantidadPago",
                    }                          

                ],


    }
  },

  components: {
            Button,
            Table,
            'v-select': vSelect,
            FormWizard,
            TabContent
        },
        
  created() {

    if(this.id_rol == 1){
       this.$vs.loading();
       this.getAlumnos();
       this.getAnios();
       this.getPeriodosList();
     }

  },
  mounted(){

  },
  watch: {
  },
  methods: {

getPeriodosList(){

                    this.periodoList={};
                    this.$http.get("get_periodos").then(
                        response => {
                            this.periodosList = response.data.periodos;
                            this.$vs.loading.close();
                        },
                        error => {
                            this.StepError(error);
                        }
                    );
                },
  onChangePeriodoList:function () {
                if(this.periodoList !== ""){
                    this.getAlumnos();
                    // this.carreraListSelected={};
                }else{
                    this.getAlumnos();
                    this.periodoList={};
                    this.total={};
                    // this.carreraListSelected={};
                }

            },

        // onChangeCarreraList:function(){
                
        //         if(this.carreraListSelected !== ""){
        //             this.getAlumnos();
        //         }
        //         else{
        //             this.carreraListSelected={}
        //             this.getAlumnos();
        //         }

        //     },

     getAnios(){
                this.$http.get("get_anios").then(
                        response => {
                            this.anios = response.data.anios;
                            this.$vs.loading.close();
                        },
                        error => {
                            this.StepError(error);
                        }
                    );
            },

  //  submitForm() {
  //               this.$validator.validateAll().then(result => {
  //                   if(result) {
  //                      let tokenStorage=localStorage.getItem('app-token');

  //                       this.$http.post("save_alumno",{token:tokenStorage,data:this.formAlumno}).then(
  //                           response => {
  //                               if(response.data.resultado==="ok"){ 
  //                                   this.$vs.notify({ color: 'success', title: 'Registro guardado', text: 'Se guardo el registro correctamente' });
  //                                   this.formAlumno={};
  //                                   this.formModalAlumno=false;
  //                                   this.getAlumnos();

  //                               }else{
  //                                   this.$vs.notify({
  //                                       time: 2500,
  //                                       title: 'Error',
  //                                       text: response.data.resultado,
  //                                       iconPack: 'feather',
  //                                       icon: 'icon-alert-circle',
  //                                       color: 'danger'
  //                                   });
  //                               }
                                
  //                           },
  //                           error => {
  //                               if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
  //                               this.$router.push({name:'pageLogin'});
  //                               localStorage.clear();
  //                               location.reload()
  //                               }
  //                               this.StepError(error);
  //                           }
  //                       );
  //                   }else{
                       
  //                   }
  //               })
  //           },

  // editar(id){
  //               this.$http.get("get_alumno/"+id).then(
  //                   response => {
  //                       this.formAlumno = response.data.alumno;
  //                       this.formModalAlumno=true;

  //                   },
  //                   error => {
  //                       this.StepError(error);
  //                   }
  //               );
  //           },

    // getCuatrimestreActual(){
    //   this.$http.get("cuatrimestre_actual").then(
    //       response => {
    //         this.cuatrimestre_actual = response.data.cuatrimestre_actual;
          
    //         this.getCarreras();
    //               },
    //       error => {
    //         this.StepError(error);
    //       }
    //   );
    // },
    
    getAlumnos() {
      let tokenStorage=localStorage.getItem('app-token');

     var anio = this.anioList.anio;
     var periodo = this.periodoList.id;
      // var idcarrera = this.carreraListSelected.id;      

      this.$http.post("alumnos_re_inscritos",{token:tokenStorage,anio,periodo}).then(
          response => {
            this.alumnos = response.data.alumnos_re_inscritos;
            this.total=Object.keys(this.alumnos).length;
            this.$vs.loading.close();
          },
          error => {
            if(error.response.data.hasOwnProperty('error') && error.response.data.error==="Token no válido" ){
              this.$router.push({name:'pageLogin'});
              localStorage.clear();
              location.reload()
            }
            this.StepError(error);
          }
      );
    },
    // getCarreras() {
    //   this.$http.get("carreras").then(
    //       response => {
         
    //         this.carreras = response.data.carreras;
   

    //       },
    //       error => {
    //         this.StepError(error);
    //       }
    //   );
    //   this.$http.get("carrera_id/" + this.carrera).then(
    //       response => {
      
    //         this.carreras_select = response.data.carrera[0];
       
    //       },
    //       error => {
    //         this.StepError(error);
    //       }
    //   );
    // },

    // ver_materias(alumno){
    //   localStorage.setItem('matricula', alumno.matricula)
    //   localStorage.setItem('id', alumno.idAlumno)
    //   this.$router.push('/directores/materias_alumno_director')
    // },
    // ver_kardex(alumno){
    //   localStorage.setItem('matricula', alumno.matricula)
    //   localStorage.setItem('id_alumno', alumno.id)

    //   this.$router.push('/administrativos/kardex')
    // },

  //  getEstados(){
         
  //              this.$http.get("catalogos/get_estados").then(
  //                  response => {
  //                      this.estados = response.data.estados;
                       

  //                  },
  //                   error => {
  //                       this.StepError(error);
  //                   }
  //               );
                
  //           },
       
  //    getMunicipio(){
               
  //              this.$http.get("catalogos/get_municipios/"+this.formAlumno.estado_id.id).then(
  //                  response => {
  //                      this.municipios = response.data.municipios;
  //                          },
  //                   error => {
  //                       this.StepError(error);
  //                   }
  //               );
                
  //           },
            
    // ver_estatus(id){
               
    //            this.$http.get("get_estatus_alumno/"+id).then(
    //                response => {
    //                    this.formEstatus = response.data.estatus_alumno;
    //                     this.modalEstatus=true;

    //                },
    //                 error => {
    //                     this.StepError(error);
    //                 }
    //             );
                
    //         },

  
  },
}
</script>